import { render, staticRenderFns } from "./Modern-Web-Development.vue?vue&type=template&id=9ea7f882&scoped=true&"
import script from "./Modern-Web-Development.vue?vue&type=script&lang=js&"
export * from "./Modern-Web-Development.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea7f882",
  null
  
)

export default component.exports